/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Route, Redirect } from 'react-router';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import uiTheme from './app.theme';
import Main from './main';
import Navigator from './navigator';
import { MessageListener, QueryToState } from './components';
import { Login, ForgotPassword, MissingRole } from './unsecured';
import { allowedRoles } from './models';
import config from '../run-config';

class App extends Component {
  constructor(props) {
    super(props);

    document.documentElement.style.setProperty('--main-color', config.mainColor);
  }

  componentDidUpdate() {
    const { loggedIn } = this.props;

    if (!loggedIn) {
      this
        .props
        .navigateToLogin();
    }
  }

  render() {
    const { loggedIn, roles } = this.props;

    const hasAllowedRole = allowedRoles.some(role => roles.includes(role));


    // HomeRoute prevents rendering of Main-Component when pathname is /Login
    const SecureHomeRoute = ({
      /* eslint-disable */
      component: Component,
      ...rest
      /* eslint-enable */
      /* eslint-disable react/destructuring-assignment */
    }) => (
      <Route
        {...rest}
        render={(props) => {
          if (props.location.pathname !== '/login') {
            if (!loggedIn) {
              return <Redirect to="/login" />;
            }
            if (!hasAllowedRole) {
              return <Redirect to="/missingrole" />;
            }

            return <Component {...props} />;
          }
          return null;
        }}
      />
    );

    const basename = window.location.pathname.includes('reportsbeta') ? config.baseRoute : '/reporting';

    return (
      <Router basename={basename}>
        <MuiThemeProvider theme={uiTheme}>
          <div>
            <Navigator />
            <Route path="/" component={MessageListener} />
            <Route path="/" component={QueryToState} key={loggedIn ? 'QueryLoggedIn' : 'QueryLoggedOut'} />
            <Switch>
              <Route path="/forgotpassword" component={ForgotPassword} />
              <Route path="/login" component={Login} />
              <Route path="/missingrole" component={MissingRole} />
              <SecureHomeRoute path="/" component={Main} />
            </Switch>
          </div>
        </MuiThemeProvider>
      </Router>
    );
  }
}

App.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  roles: PropTypes.array,
  navigateToLogin: PropTypes.func.isRequired,
};

App.defaultProps = {
  roles: [],
};

export default App;
